if ($('#app-buyer-invoices-table').length) {
    var data_table_order = [0, "desc"];
    var app_buyer_invoices_table_all = $('#app-buyer-invoices-table').DataTable({
        "processing": true,
        "serverSide": true,
        ajax: {
            url: '/buyer-invoices',
            dataSrc: 'data',
        },
        order: [0, "desc"],
        columns: [
            {data: 'id'},//0
            {data: 'original_filename'},//1
            {data: 'number'},//2
            {data: 'vendor'},//3
            {data: 'buyer_agency'},//4
            {data: 'amount'},//5
            {data: 'user'},//6
            {data: 'created_at'},//7
            {data: 'posted_by'},//8
            {data: 'posted_at'},//9
            {data: 'id'} //10
        ],
        // destroy: true,
        pageLength: user_entries,
        "columnDefs": [
            {
                "targets": 0,
                "visible": true,
                "orderable": false,
                "className": "text-center",
                "createdCell": function (td, cellData, rowData, row, col) {
                    var html = ' <div class="checkbox checkbox-danger buyer_invoices_check"> <input class="checkbox" class="form-control" type="checkbox"  id="' + rowData.id + '" name="selected_buyer_agencies[]" value="' + rowData.id + '" ><label for="' + rowData.id + '"> </label></div>';
                    $(td).html(html);
                }
            },
            {
                "targets": 1,
                "orderable": true,
            },
            {
                "targets": 2,
                "orderable": true,
                "visible": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    $(td).html(cellData.replace(/ /g, ', '));
                }
            },
            {
                "targets": 3,
                "orderable": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    $(td).html(cellData);
                }
            },
            {
                "targets": 4,
                "orderable": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    return $(td).html(rowData.buyer_agency.name);
                }
            },
            {
                "targets": 5,
                "orderable": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    return $(td).html('$' + cellData ).css('font-weight', 'bold');
                }
            },
            {
                "targets": 6,
                "orderable": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    return $(td).html(rowData.user.name);
                }
            },
            {
                "targets": 7,
                "orderable": true,
            },
            {
                "targets": 8,
                "orderable": true,
            },
            {
                "targets": 9,
                "orderable": true,
            },
            {
                "targets": 10,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    console.log('rowData', rowData)
                    var html = '';
                    var auxHtml = '';
                    var html = '<div class="btn-group">\n' +
                        '            <button type="button" class="btn btn-outline btn-success waves-effect waves-light m-r-5 btn-off" data-toggle="dropdown">\n' +
                        '                <i class="fa fa-ellipsis-v"></i>\n' +
                        '                <span class="sr-only">Toggle Dropdown</span>\n' +
                        '            </button>\n' +
                        '            <ul class="dropdown-menu dropdown-menu-right">\n' +
                        '                             <li class="ms-hover">' + '<a class="populate-avail-proposal" href="javascript:void(0)" data-name="' + rowData.original_filename + '" data-id="' + rowData.id + '" >' + '<i class="fa fa-paper-plane"></i> Post Invoice' + '</a>' + '</li>' +
                        '                             <li class="ms-hover">' + '<a class="download-avail-proposal" download href="/buyer-invoices/download/file/' + rowData.id + '" data-name="' + rowData.original_filename + '" data-id="' + rowData.id + '" >' + '<i class="fa fa-cloud-download"></i> Download File' + '</a>' + '</li>' +
                        '  </ul>\n' +
                        '  </div>';

                    $(td).html(html);
                }
            }
        ]
    });

    $('#select_all_buyer_agencies').on('click', function (e) {
        $('#app-buyer-invoices-table input:checkbox').prop('checked', true);
    });
    $('#deselect_all_buyer_agencies').on('click', function (e) {
        $('#app-buyer-invoices-table input:checkbox').prop('checked', false);
    });

    $('#populate_proposals').on('click', function () {
        var proposals = [];
        $('.buyer_invoices_check input[type=checkbox]').each(function () {
            if (this.checked)
                proposals.push($(this).val());
        });
        if(proposals.length > 0) {
            swal({
                    title: "Warning",
                    text: "Are you sure to post selected invoices?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        show_loader()
                        var request = {
                            'lines': proposals,
                        };
                        $.ajax({
                            type: 'POST',
                            url: '/buyer-invoices/post',
                            data: JSON.stringify(request),
                            contentType: "application/json; charset=utf-8",
                            dataType: "json",
                            traditional: true,
                            headers: {
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            },
                            success: function (data) {
                                global_notification('success', "Invoices posted...");
                                setTimeout(function () {
                                    location.reload();
                                }, 1000);
                            },
                            error: function (xhr) {
                                ajax_error();
                                debug(xhr.responseText);
                                hide_loader();
                            }
                        });
                    }
                });
        } else {
            swal({
                    title: 'Warning!',
                    text: 'Please selecte at least one proposal.',
                    type: 'warning',
                    showCancelButton: false,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Ok",
                    cancelButtonText: "Cancel",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                });
        }
    });

    $('#app-buyer-invoices-table').on('click','.populate-avail-proposal', function () {
        var proposals = [$(this).attr('data-id')];
        swal({
                title: "Warning",
                text: "Are you sure to post this invoice?",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    show_loader()
                    var request = {
                        'lines': proposals,
                    };
                    $.ajax({
                        type: 'POST',
                        url: '/buyer-invoices/post',
                        data: JSON.stringify(request),
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        traditional: true,
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        },
                        success: function (data) {
                            global_notification('success', "Invoice posted...");
                            setTimeout(function () {
                                location.reload();
                            }, 1000);
                        },
                        error: function (xhr) {
                            ajax_error();
                            debug(xhr.responseText);
                            hide_loader();
                        }
                    });
                }
            });
    });
}

var hadv = null;
var hcamp = null;
var save_tby_file=false;
var save_lines=[];

if ($('#app-buyer-invoices').length) {
    var manual_or_imported=0;

    /**
     * Pusher
     */

    Pusher.logToConsole = true;
    var pusher = new Pusher($('meta[name="pusher-key"]').attr('content'), {
        cluster: $('meta[name="pusher-cluster"]').attr('content'),
        encrypted: true,
    });


    Dropzone.autoDiscover = false;
    var duplicated_global = [];

    var invoice_dropzone_func = function () {
        var invoice_dropzone = new Dropzone('#invoice_dropzone', {
            url: "/buyer-invoices/upload",
            dictDefaultMessage: "Drag'n'Drop invoices here or use the 'Add Files' button below. Only TXT, EDI, BUY, NCC, CSV, INV, PDF or DAT files are allowed. (Up to 10 files)",
            acceptedFiles: ".txt, .edi, .dat, .buy, .ncc, .csv, .inv, .pdf",
            dictInvalidFileType: {error: "Incorrect file type. Only TXT, EDI, BUY, NCC, CSV, INV or DAT files are allowed. Please try changing file extension."},
            addRemoveLinks: true,
            maxFiles: 1000,
            previewTemplate: document.getElementById('preview-template').innerHTML,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            clickable: ['#invoice_dropzone', '#invoice_dropzone_add_files']
        });

        invoice_dropzone.on('sending', function (file, xhr, formData) {
            $(file.previewElement).find('div.invoice-progress').html('<i class="fa fa-fw fa-spinner fa-spin"></i> Uploading')
                .removeClass('text-info').addClass('text-primary');
        });

        invoice_dropzone.on('uploadprogress', function (file, progress, bytesSent) {
            if (progress == 100) {
                $(file.previewElement).find('div.invoice-progress').html('<i class="fa fa-fw fa-spinner fa-spin"></i> Verifying');
            }
        });

        invoice_dropzone.on('success', function (file) {
            var preview = $(file.previewElement);
            preview.addClass('verified');
            preview.find('div.invoice-progress').html('<i class="fa fa-check fa-fw"></i> Verified')
                .removeClass('text-primary').addClass('text-success');
            preview.find('[data-dz-remove]').attr('disabled', null);

            update_invoice_button();
        });

        invoice_dropzone.on('removedfile', function (file) {
            if (file.status == "success") {
                var file_response = $.parseJSON(file.xhr.response);
                $.ajax({
                    type: 'POST',
                    url: '/buyer-invoices/destroy/',
                    data: {
                        'id': file_response.data.id
                    },
                    dataType: 'json',
                    encode: true,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function () {
                        global_notification('success', 'Pending Invoice removed.');
                    },
                    error: function () {
                        ajax_error();
                    }
                });
            }
            update_invoice_button();
        });

        invoice_dropzone.on('error', function (file, response) {
            if (response !== 'Upload canceled.') {
                global_notification('error', '<b>ERROR</b> UPLOADING FILE <b>' + file.name + '</b>: ' + response.error);

                setTimeout(function () {
                    console.log('ERROR UPLOADING FILE: ' + file.name + ' - ' + response.error);
                }, 2000);

                invoice_dropzone.removeFile(file);
            } else
                global_notification('success', response);
        });

        var update_invoice_button = function () {
            var files = invoice_dropzone.getAcceptedFiles();

            var temp = true;

            $.each(files, function (index, value) {
                if (!$(value.previewElement).hasClass('verified')) {
                    temp = false;
                }

                if (temp) {
                    $('#invoice_dropzone_continue').attr('disabled', null);
                } else {
                    // File passed Verification
                    $('#invoice_dropzone_continue').attr('disabled', 'disabled');
                }
            });
        };

        $('#invoice_dropzone_continue').on('click', function () {

            var advs = $("#advertiser_searchs option:selected").val();
            var camps = $("#campaign_searchs option:selected").val();
            $('.content-wrap').html('');
            $("#progress-content").html("");
            var files = invoice_dropzone.getAcceptedFiles();
            var ids = [];
            var count = 0;
            console.log("files");
            console.log(files);
            $('.div-with-errors').html('');
            $.each(files, function (index, value) {
                count++;

                var html = '<div class="row" id="row-' + count + '" style="dislplay: none">' +
                    '<div class="m-b-10">' +
                    '<div class="col-xs-6 text-center">' +
                    '<span class="name" id="file-' + count + '"></span>' +
                    '</div>' +
                    '<div class="col-xs-6 text-left">' +
                    '<div id="progress-' + count + '"></div>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<br />';
                $("#progress-content").append(html);

                console.log("response");
                console.log(value.xhr.response);
                var file_response = $.parseJSON(value.xhr.response);
                ids.push(file_response.data.id);

                $('#file-' + count).html(file_response.data.original_filename);
                $('#progress-' + count).html('<i class="fa fa-fw fa-spinner fa-spin"></i><span class="message">Queued</span></div>');
                $('#row-' + count).css('display', 'block');
            });
            $("#progress-content").css("display", "block");

            channel = pusher.subscribe('invoices', function () {
                console.log('listening on channel "invoices"');
            });

            count = 1;

            channel.bind('App\\Events\\InvoiceUploadProgressEvent', function (event) {
                console.log('***************************************************************************************************************');
                console.log('event ', event);
                if (event.upload.state == 'error') {
                    $('#progress-' + count).html('<div class="progress-' + event.upload.id + '" id="progress-' + event.upload.id + '">' +
                        '<i class="fa fa-fw fa-times"></i><span class="message text-danger">' + event.upload.state + ' - ' + event.upload.state_message + '</span></div>');
                    count++;
                    $('.div-with-errors').append(event.upload.original_filename + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="message text-danger">' + event.upload.state + ' - ' + event.upload.state_message + '</span><br>');
                } else if (event.upload.state == 'Completed') {
                    $('#progress-' + count).html('<div class="success progress-' + event.upload.id + '" id="progress-' + event.upload.id + '">' +
                        '<i class="fa fa-fw fa-check"></i><span class="text-success">' + event.upload.state + '</span></div>');
                    count++;
                } else {
                    $('#progress-' + count).html('<div class="text-info progress-' + event.upload.id + '" id="progress-' + event.upload.id + '">' +
                        '<i class="fa fa-fw fa-spinner fa-spin"></i><span class="message">' + event.upload.state + '</span></div>');
                }
                //$('#invoice-upload-messages').append('<div id="message-'+event.upload.id+'">'+event.upload.id+'&nbsp;:<i class="fa fa-fw fa-spinner fa-spin"></i><span class="message">' + event.upload.state + '</span></div>');
            });

            $.ajax({
                type: 'POST',
                url: '/buyer-invoices/init',
                data: {
                    'ids': ids,
                    // 'advertiser': hadv,
                    // 'campaign': hcamp
                },
                dataType: 'json',
                encode: true,
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                success: function (data) {
                    console.log('data_data_data_data_ html div error', data);
                    console.log('data_data_data_data_', data);
                    $('#invoices_number').val(0);
                    var duplicated = {};
                    duplicated_global = {};
                    var show_error_div = false;
                    show_modal_import();

                    $('#invoice_import_tab1').removeClass('tab-current');
                    $('#invoice_import_tab2').addClass('tab-current');
                    $('#invoice_upload').removeClass('content-current');
                    $('#invoice_process').addClass('content-current');


                    function show_modal_import() {
                        if (data.count > 0) {
                            $('#invoices_number').val(data.count);
                            var html = '<div class="col-sm-12" style="margin-bottom: 1%; padding: 5px;  background-color: #ADD8E6;' +
                                '                                        color: #2b2b2b; font-size: 12px;' +
                                '                                        box-shadow: 0 4px 4px -2px rgba(0, 0, 0, .2);' +
                                '                                        -moz-box-shadow: 0 4px 4px -2px rgba(0, 0, 0, .2);' +
                                '                                        -webkit-box-shadow: 0 4px 4px -2px rgba(0, 0, 0, .2);"> ';
                            html += '<div class="col-sm-3 text-break" style=""><strong>FILE NAME </strong></div> ' +
                                '<div class="col-sm-2 text-break" style=""><strong>INV. NUMBER </strong></div> ' +
                                '<div class="col-sm-2 text-break" style=""><strong>INV. STATION </strong></div> ' +
                                '<div class="col-sm-1 text-break" style=""><strong>AGENCY </strong></div> ' +
                                '<div class="col-sm-1 text-break" style=""><strong>AMOUNT</strong></div> ' +
                                '<div class="col-sm-3" style=""></div> ' +
                                '</div>';
                            var xxx = 0;
                            for (var index in data.datas) {
                                var import_invoice = /*data.datas[index]['invoice'].invoice_number_exist === 1 && invoices_list_dup_import.indexOf(data.datas[index]['invoice'].invoice_number) === -1 ? false :*/ true;

                                if (import_invoice === true) {
                                    html += '<div  class="col-sm-12">';
                                    html += '<div class="col-sm-3"> ' + data.datas[index]['invoice']['original_filename'] + ' </div>';
                                    html += '<div class="col-sm-2"> ' + data.datas[index]['invoice']['number'].replace(/ /g, ', ') + ' </div>';
                                    html += '<div class="col-sm-2"> ' + data.datas[index]['invoice']['vendor'].replace(/ /g, ', ') + ' </div>';
                                    html += '<div class="col-sm-1"> ' + data.datas[index]['invoice']['agency_name'] + ' </div>';
                                    html += '<div class="col-sm-1"> ' + data.datas[index]['invoice']['amount'] + ' </div>';

                                    //fill campaigns
                                    var aux_html = '';
                                    var sel_adv = '';
                                    var sel_camp = '';
                                    aux_html += '<div class="col-sm-3"><select class="form-control full-width select-camp-import" id="cam_' + xxx + '" name="cam_' + xxx + '" data-id="' + index + '" data-invoice-number="' + data.datas[index].id + '"><option></option>';
                                    if (data.datas[index]['agencies'] !== null) {
                                        for (var x in data.datas[index]['agencies']) {
                                            var sel = data.datas[index]['agencies'][x].id === data.datas[index]['id'];
                                            aux_html += '<option value="' + data.datas[index]['agencies'][x].id + '_' + index + '" ' + (sel ? 'selected' : '') + ' data-toggle="tooltip" class="tooltip-init" title="' +
                                                data.datas[index]["agencies"][x].name + ' " >' + data.datas[index]["agencies"][x].name + '</option>';
                                        }
                                    }
                                    aux_html += '</select></div>';
                                    aux_html += '</div>';
                                    html += aux_html;
                                    xxx++;
                                }
                            }
                            $('.invoices_list_show').html('');
                            $('.invoices_list_show').html(html);

                            $(".invoices_list_show .select-camp-import").tooltip({
                                title: function () {
                                    return $(this).prev().attr("title");
                                },
                                placement: "auto"
                            });

                            $('.invoices_list_show').find('.select-camp-import').each(function () {
                                $(this).select2({
                                    placeholder: "Select one...",
                                    minimumResultsForSearch: 3
                                });
                            });

                            $('#InvSelectCampaignAdv').modal({backdrop: 'static', keyboard: false})
                            $('#InvSelectCampaignAdv').modal('show');
                        } else
                            $('#invoice_finish').css('display', 'block');

                        $('.div-display-error').css('display', 'none');
                    }
                },
                error: function (xhr) {
                    console.log(xhr);
                    console.log('AJAX ERROR: ' + xhr.responseText);
                    debug(xhr.responseText);
                    ajax_error();
                    global_notification('error', 'All Invoices Could Not Be Imported!' + xhr.responseText);
                    $('.content-wrap').html('');
                    /*  setTimeout(function () {
                          location.reload();
                          0
                      }, 2000)
                      */
                }
            });
            //}
        });
    };
    $('#export_duplicated_inv').on('click', function (){
        var html = ' <table style="width: 100%; font-size: 18px"><tr><td colspan="3"><b>The following Invoice(s) have not been imported:</b></td></tr></table>';

        for(var  file_name in duplicated_global){
            html += ' <table style="width: 100%; font-size: 15px"><tr><td style="margin-top: 1%">File Name: <span style="color: #F47A51">'+ file_name +'</span></td></tr></table>';
            var color_count = 0;
            for(var num in duplicated_global[file_name]) {
                var color = color_count %2 !== 0 ? 'white': '#f6f6f6';
                color_count++;
                html += ' <table style="width: 100%; font-size: 15px"><tr style="background-color: '+ color +'">' +
                    '<td style="margin-top: 1%; text-align: center">Invoice #: '+ duplicated_global[file_name][num].number +'</td>' +
                    '<td style="margin-top: 1%; text-align: center">Existing Invoice Station: '+ duplicated_global[file_name][num].station +'</td>';
                html += ' <td style="margin-top: 1%">Existing Invoice Month: '+ moment(duplicated_global[file_name][num].month).format('MMM, YYYY')  +'</td></tr></table>';
            }
            html += ' <table style="width: 100%; font-size: 15px"><tr><td colspan="3"></td></tr></table>';
        }

        var a = document.createElement('a');
        var data_type = 'data:application/vnd.ms-excel';
        a.href = data_type + ', ' + encodeURIComponent(html);
        a.download = 'exported_' + moment().format('MM-DD-YYYY')  + '.xls';
        //triggering the function
        a.click();
        return false;

    });
    $('#export_duplicated_inv_first').on('click', function (){
        var html = ' <table style="width: 100%; font-size: 18px"><tr><td colspan="4"><b>The following invoice number(s) already exist. They can be imported with a new Invoice Number:</b></td></tr></table>';

        for(var  file_name in duplicated_global){
            html += ' <table style="width: 100%; font-size: 15px"><tr><td colspan="4" style="margin-top: 1%">File Name: <span style="color: #F47A51">'+ file_name +'</span></td></tr>';
            var color_count = 0;
            for(var num in duplicated_global[file_name]) {
                var color = color_count %2 !== 0 ? 'white': '#f6f6f6';
                color_count++;
                html += ' <tr style="background-color: '+ color +'">' +
                    '<td style="margin-top: 1%; text-align: left">Invoice #: <span style="color: #F47A51">'+ duplicated_global[file_name][num].number +'</span></td>' +
                    '<td style="margin-top: 1%; text-align: left">Existing Invoice Station: <span style="color: #F47A51">'+ duplicated_global[file_name][num].station +'</span></td>';
                html += ' <td style="margin-top: 1%; text-align: left">Existing Invoice Month: <span style="color: #F47A51">'+ moment(duplicated_global[file_name][num].month).format('MMM, YYYY')  +'</span></td>';
                html += ' <td style="margin-top: 1%; text-align: left" >New Inv. #: <span style="color: #F47A51">'+ duplicated_global[file_name][num].number  +'_1</span></td></tr>';
            }
            html += '<tr><td colspan="4"></td></tr></table>';
        }

        var a = document.createElement('a');
        var data_type = 'data:application/vnd.ms-excel';
        a.href = data_type + ', ' + encodeURIComponent(html);
        a.download = 'exported_' + moment().format('MM-DD-YYYY')  + '.xls';
        //triggering the function
        a.click();
        return false;

    });

    $('#send_finish_invoice_').on('click', function () {
        var html = '';
        var i = 0;
        $('.invoices_list_show').find('.select-camp-import').each(function () {
            if (typeof $(this).children("option:selected").val() !== 'undefined' && $(this).children("option:selected").val() != '') {
            } else {
                if (i == 0)
                    html += $(this).attr('data-invoice-number');
                else
                    html += ', ' + $(this).attr('data-invoice-number');
                i++;
            }
        });
        if (html != '') {
            swal({
                    title: "Warning!",
                    text: "The following invoice(s) will not be imported: " + html + ". Do you want to continue? ",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Continue",
                    cancelButtonText: "Cancel",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        var array = $('#invoice_camp_adv_form').serializeArray();
                        show_overlay_loader($('#InvSelectCampaignAdv .modal-content'));
                        $.ajax({
                            type: 'POST',
                            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                            data: array,
                            url: '/buyer-invoices/import/finalize/process',
                            dataType: "json",
                            encode: true,
                            success: function (data) {
                                console.log('data', data);
                                if(data.length === 0 ) {
                                    global_notification('success', 'Invoice(s) Imported.');
                                    hide_overlay_loader($('#InvSelectCampaignAdv .modal-content'));
                                    setTimeout(function () {
                                        location.reload();
                                    }, 1000);
                                }
                                else{
                                    var text = '';
                                    for(var ind in data)
                                        text += data[ind]+'<br>';
                                    $('#invoice_already_exist_manual').html(text);
                                    hide_overlay_loader($('#InvSelectCampaignAdv .modal-content'));
                                    $('#modalAlreadyExist').modal({backdrop: 'static', keyboard: false})
                                    $('#modalAlreadyExist').modal('show');
                                }

                            },
                            error: function (xhr) {
                                hide_overlay_loader($('#InvSelectCampaignAdv .modal-content'));
                                ajax_error();
                                debug(xhr.responseText);

                            }
                        });

                    }
                });
        } else {
            swal({
                    title: "Warning!",
                    text: "Are you sure you want to continue?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Continue",
                    cancelButtonText: "Cancel",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        var array = $('#invoice_camp_adv_form').serializeArray();
                        show_overlay_loader($('#InvSelectCampaignAdv .modal-content'));
                        $.ajax({
                            type: 'POST',
                            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                            data: array,
                            url: '/buyer-invoices/import/finalize/process',
                            dataType: "json",
                            encode: true,
                            success: function (data) {
                                console.log('data', data);
                                if(data.length === 0 ) {
                                    global_notification('success', 'Invoice(s) Imported.');
                                    hide_overlay_loader($('#InvSelectCampaignAdv .modal-content'));
                                    setTimeout(function () {
                                        location.reload();
                                    }, 1000);
                                }
                                else{
                                    var text = '';
                                    for(var ind in data)
                                        text += data[ind]+'<br>';
                                    $('#invoice_already_exist_manual').html(text);
                                    $('#modalAlreadyExist').modal({backdrop: 'static', keyboard: false})
                                    hide_overlay_loader($('#InvSelectCampaignAdv .modal-content'));
                                    $('#modalAlreadyExist').modal('show');
                                }

                            },
                            error: function (xhr) {
                                hide_overlay_loader($('#InvSelectCampaignAdv .modal-content'));
                                ajax_error();
                                debug(xhr.responseText);

                            }
                        });

                    }
                });
        }
    });
    $('.reload_page').on('click', function () {
        show_overlay_loader($('#InvSelectCampaignAdv .modal-content'));
        setTimeout(function () {
            location.reload();
        }, 1000);
    });
    $('#InvSelectCampaignAdv').on('hide.bs.modal', function (e) {
        if(!modal_hided) {
            e.stopPropagation();
            e.preventDefault();
            swal({
                    title: "Warning!",
                    text: "Are you sure you want to exit?\nNo Invoice(s) will be imported.",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        $('#InvSelectCampaignAdv').modal('hide');
                        setTimeout(function(){
                            location.reload();
                        }, 1000);
                    }
                });
        }
    })

    $('.show_modal_import_button_close').on('click', function (e) {
        swal({
                title: "Warning!",
                text: "Are you sure you want to exit?\nNo Invoice(s) will be imported.",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "OK",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $('#InvSelectCampaignAdvAlreadyExist').modal('hide');
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }
            });

    })

    $(document).ready(function () {
        invoice_dropzone_func();
        $('#invoice_finish').on('click', function () {

            setTimeout(function(){
                location.reload();
            }, 1000);

        });
    });

    var invoice_match_modal = function (el) {
        var upload_id = $(el).attr('data-invoice-id');
        var modal = $('#invoice_match');
        modal.find('input[name="invoice_upload_id"]').val(upload_id);
        modal.find('select[name="invoice_campaign_id"]').html('').append('<option value=""></option>')

        $.ajax({
            type: 'GET',
            url: '/campaigns/all',
            dataType: 'json',
            success: function (data) {
                $.each(data, function (index, value) {
                    modal.find('select[name="invoice_campaign_id"]').append('<optgroup label="' + value.name + '">');
                    $.each(value['campaigns'], function (index, value) {
                        modal.find('select[name="invoice_campaign_id"]').append('<option value="' + value.id + '">' + value.name + "</option>");
                    });
                    modal.find('select[name="invoice_campaign_id"]').append("</optgroup>");
                    modal.find('button.invoice_campaign_match').unbind('click').bind('click', function () {
                        modal_match_campaign(this);
                    });
                    modal.modal("show");
                });
            }
        });
    };

    var modal_match_campaign = function (el) {
        var modal = $(el).closest('.modal');

        var data = {
            'invoice_upload_id': modal.find('input[name="invoice_upload_id"]').val(),
            'campaign_id': modal.find('select[name="invoice_campaign_id"]').val()
        };

        $.ajax({
            type: 'POST',
            url: '/buyer-invoices/match',
            data: data,
            dataType: 'json',
            encode: true,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                modal.modal("hide");
                global_notification('success', 'Invoices matched with campaign successfully.');
            }
        });
    };

    $('#select_all_inv').on('click', function (e) {
        var auxc = 0;
        $('#app-invoices-table input:checkbox').each(function () {
            if ($(this).prop('disabled')=== false) {
                $(this).prop('checked', true);
                auxc++;
            }
        });
        if(auxc > 1)
            $('#multiple_match').attr('disabled', false);

        var selected=[];
        var mmm=false; var man = false; var imp = false;
        var all_imported = true;
        var all_manual = true;
        $('.invoices_check input[type=checkbox]').each(function () {
            if (this.checked) {
                selected.push($(this).val());
                if($(this).val().toString().indexOf('m_') !== -1)
                    man = true;
                else
                    imp = true;
                if ($(this).val().toString().indexOf('m_') !== -1 && $(this).attr('data-total-only') == 1) {
                    all_imported = false;
                    all_manual = false;
                }
                else if ($(this).val().toString().indexOf('m_') !== -1)
                    all_imported = false;
                else
                    all_manual = false;
                if (mmm == false) {
                    var row = app_invoices_table.row($(this).attr('data-row')).data();
                    console.log('cccccccccccccccccccccccc');
                    console.log($(this).attr('data-row'));
                    console.log(row);
                    if (row.multiple_match > 0 || row.match_id > 0)
                        mmm = true;
                }
            }
        });
        // if(man === true)
        //     $('#multiple_match').attr('disabled', 'disabled');
        // else
        //     $('#multiple_match').attr('disabled', false);
        console.log('all_imported ...', all_imported);
        console.log('all_manual ...', all_manual);
        // if (man === true)
        //     $('#multiple_match').attr('disabled', 'disabled');
        // else
        //     $('#multiple_match').attr('disabled', false);
        if(selected.length > 1 && (all_imported === true || all_manual === true) ) {
            $('#multiple_match').attr('disabled', false);
            if(all_imported === true)
                $('#multiple_match').attr('data-invoice-type', 'imported');
            else
                $('#multiple_match').attr('data-invoice-type', 'manual');
        }
        else
            $('#multiple_match').attr('disabled', 'disabled');
        console.log("man: " + man);
        if(mmm==false)
            $('#delete_multiple_invo').attr('disabled', false);
        else
            $('#delete_multiple_invo').attr('disabled', 'disabled');
    });

    $('#deselect_all_inv').on('click', function (e) {
        $('#app-invoices-table input:checkbox').prop('checked', false);
        $('#multiple_match').attr('disabled', true);

        var selected=[];
        var mmm=false; var man = false; var imp = false;
        $('.invoices_check input[type=checkbox]').each(function () {
            if (this.checked) {
                selected.push($(this).val());
                if($(this).val().toString().indexOf('m_') !== -1)
                    man = true;
                else
                    imp = true;
                if (mmm == false) {
                    var row = app_invoices_table.row($(this).attr('data-row')).data();
                    console.log('cccccccccccccccccccccccc');
                    console.log($(this).attr('data-row'));
                    console.log(row);
                    if (row.multiple_match > 0 || row.match_id > 0)
                        mmm = true;
                }
            }
        });
        if(man === true)
            $('#multiple_match').attr('disabled', 'disabled');
        else
            $('#multiple_match').attr('disabled', false);
        console.log("man: " + man);
        if(mmm==false)
            $('#delete_multiple_invo').attr('disabled', false);
        else
            $('#delete_multiple_invo').attr('disabled', 'disabled');
    });

    var delete_invoice= function () {
        var id = $('#hidden_id_to_delete').val();
        var row = $('#hidden_row_to_delete').val();
        var url = '/buyer-invoices/delete_invoice/' + id;
        // if($('#hidden_type_to_delete').val() == 'manual')
        //     url = '/buyer-invoices/delete_manual_invoice/from_order/' + id;

        $.ajax({
            type: 'GET',
            url: url,
            dataType: 'json',
            encode: true,
            success: function (data) {
                global_notification('success', 'Invoice deleted.');
                app_invoices_table.row(row).remove().draw();
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });
    }

    $('#archive_all_inv').on('click', function (e) {
        var url = $(this).attr('data-url');
        var selectedItems = [];
        var selectedItemsRows = [];
        $('.invoices_check input[type=checkbox]').each(function () {
            if (this.checked) {
                selectedItems.push($(this).val());
                selectedItemsRows.push($(this).attr('data-row'));
            }
        });

        if (selectedItems.length > 0) {
            $('#generalWarningModalArchiveInvoiceMultiple').modal('show');
        }
        else {
            $('#generalWarningModalDiv').html('Please select at least one Invoice.');
            $('#generalWarningModal').modal('show');
        }
    });
    $('#activate_multiple').on('click', function (e) {
        var url = $(this).attr('data-url');
        var selectedItems = [];
        var selectedItemsRows = [];
        $('.invoices_arch_check input[type=checkbox]').each(function () {
            if (this.checked) {
                selectedItems.push($(this).val());
                selectedItemsRows.push($(this).attr('data-row'));
            }
        });

        if (selectedItems.length > 0) {
            $('#generalWarningModalActivateInvoiceMultiple').modal('show');
        }
        else {
            $('#generalWarningModalDiv').html('Please select at least one Invoice.');
            $('#generalWarningModal').modal('show');
        }
    });
    function archiveInvoiceConfirmedMultiple(){
        var url = $('#archive_all_inv').attr('data-url');
        var selectedItems = [];

        $('.invoices_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        show_loader();
        var params = {
            invoices: selectedItems,
            activate: 0,
        };
        console.log(url);
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: url,
            dataType: "json",
            contentType: "application/json",
            success: function (data) {
                hide_loader();
                global_notification('success', 'Invoices archived.');
                window.location.href= data.redirect;
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);

            }
        });
    }
    function activateInvoiceConfirmedMultiple(){
        var url = $('#archive_all_inv').attr('data-url');
        var selectedItems = [];

        $('.invoices_arch_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        show_loader();
        var params = {
            invoices: selectedItems,
            activate: 1,
        };
        console.log(url);
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: url,
            dataType: "json",
            contentType: "application/json",
            success: function (data) {
                hide_loader();
                global_notification('success', 'Invoices activated.');
                window.location.href= data.redirect;
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);

            }
        });
    }

    $('#delete_multiple_invo').on('click', function (e) {
        var selectedItems = [];
        $('.invoices_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        $('#delete_invoice_bt').hide();
        $('#delete_invoiceMultiple').show();

        if (selectedItems.length > 0)
            $('#generalWarningModalDeleteInvoice').modal('show');
        else{
            $('#generalWarningModalDiv').html('Please select at least one Invoice.');
            $('#generalWarningModal').modal('show');
        }
    });

    function delete_invoiceMultiple() {
        show_loader();
        var selectedItems = [];
        $('.invoices_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        var params = {
            invoices: selectedItems,
        };
        var url = $('#delete_multiple_invo').attr('data-url');

        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: url,
            dataType: "json",
            contentType: "application/json",
            success: function (data) {
                $('.invoices_check input[type=checkbox]').each(function () {
                    li= $(this).val();
                    if (this.checked) {
                        $('#app-invoices-table tr').each(function () {
                            if($(this).attr('data-invoice-id') == li)
                                $(this).addClass('selected');
                        });
                    }
                });
                app_invoices_table.rows( '.selected' )
                    .remove()
                    .draw();
                global_notification('success', 'Invoices deleted.');
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);

            }
        });
    }
}